'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classesForEvent = exports.classesForEvent = function classesForEvent(event) {
  var classes = [];

  if (event.placeholder) {
    classes.push('is-placeholder');
  } else {
    if (event.commentsReleased !== 1 && event.status === 'RES') {
      classes.push('is-status-COMMENTS-UNRELEASED');
    } else {
      classes.push('is-status-' + event.status);
    }
  }

  return classes;
};


//////////////////
// WEBPACK FOOTER
// ./common/utils/classes-for-event.js
// module id = 206
// module chunks = 0